import { HiShieldCheck } from "react-icons/hi";
import { MdCancel, MdAnalytics } from "react-icons/md";
const data = [
  {
    icon: <HiShieldCheck/>,
    heading: "Optimal market interest rates",
    detail:
      "Discover the most advantageous interest rates available, tailored to meet your financial goals and aspirations.",
  },
  {
    icon: <MdCancel />,
    heading: "Secure stable pricing",
    detail:
      "We've implemented measures to prevent sudden and irregular adjustments in prices, fostering stability.",
  },
  {
    icon: <MdAnalytics />,
    heading: "Golden price opportunity",
    detail:
      "Our stellar pricing stands out!Choose from the best-priced properties, handpicked to offer superior value.",
  },
];
export default data;